/**
 * ColorField — "Default" (brand default / unset) + brand swatches + a custom picker.
 * Shared by the Action Buttons designer (modal title bar) and the Location Maps
 * designer (theme tokens).
 */

import React from 'react';

/** Trusscore brand palette — offered as quick-pick swatches above the custom picker. */
export const BRAND_SWATCHES: { label: string; value: string }[] = [
  { label: 'Brand Gold', value: '#FEB100' },
  { label: 'Slate', value: '#3a4b5c' },
  { label: 'Dark', value: '#1a1a2e' },
  { label: 'White', value: '#ffffff' },
];

export const ColorField: React.FC<{ label: string; value?: string; onChange: (v?: string) => void; defaultLabel?: string }> = ({ label, value, onChange, defaultLabel = 'Default' }) => (
  <div>
    <label className="form-label small mb-1">{label}</label>
    <div className="d-flex align-items-center gap-1 flex-wrap">
      <button type="button" className={`btn btn-sm ${!value ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => onChange(undefined)} title="Use the default">{defaultLabel}</button>
      {BRAND_SWATCHES.map(s => (
        <button
          key={s.value}
          type="button"
          title={s.label}
          aria-label={s.label}
          onClick={() => onChange(s.value)}
          style={{ width: 26, height: 26, borderRadius: 5, cursor: 'pointer', background: s.value, border: value?.toLowerCase() === s.value.toLowerCase() ? '2px solid #0d6efd' : '1px solid #ccc' }}
        />
      ))}
      <input type="color" value={value || '#ffffff'} onChange={e => onChange(e.target.value)} title="Custom colour" style={{ width: 34, height: 30, padding: 0, border: 'none', background: 'none', cursor: 'pointer' }} />
    </div>
  </div>
);

export default ColorField;
